export default "__VITE_ASSET__CGY8cV_n__"